module.exports = __webpack_public_path__ + "img/alearn_render1.e91ce1fe.jpg";